import {
  ColorBlue200,
  ColorGreen200,
  ColorOrange200,
  ColorViolet200,
  ColorYellow200,
} from '../../design-system/colors';

const supportedColors = [
  ColorGreen200,
  ColorBlue200,
  ColorOrange200,
  ColorViolet200,
  ColorYellow200,
];

const DJB2 = 5381;
function hashString(str: string): number {
  let hash = DJB2;
  for (let i = 0; i < str.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hash = (hash << 5) + hash + str.charCodeAt(i);
  }
  // eslint-disable-next-line no-bitwise
  return Math.abs(hash >>> 0);
}

export const getDeterministicColorFromName = (name: string): string => {
  const colorIndex = Math.abs(hashString(name)) % supportedColors.length;
  const newColor = supportedColors[colorIndex];
  return newColor;
};

export const getNameInitials = (name: string): string => {
  const nameParts = name
    .split(' ')
    .map((part: string) => part[0])
    .join('')
    .toUpperCase();

  return nameParts.substring(0, 2);
};
